export default __webpack_public_path__ + "static/media/BGI.fc6b0bd3.jpg";